import DashboardRouter from "./DashboardRouter";

export default DashboardRouter;